export const environment = {
  apiUrl: '',
  observabilityUrl: '/observability/client-events',
  clientApp: 'auth-ui',
  sentryDsn: '',
  release: 'dev',
  environmentName: 'development',
  telemetryEnabled: true,
};
